/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { Modal } from '@arco-design/web-vue'

function askPermission () {
  return new Promise(function (resolve, reject) {
    Notification.requestPermission().then(function (permissionResult) {
      if (permissionResult !== 'granted') {
        console.warn('你拒绝了消息通知提示')
        resolve(false)
      } else {
        resolve(true)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      askPermission().then((resolve) => {
        if (resolve) registration.showNotification('通知', { body: '应用已注册' })
      })
    },
    cached (registration) {
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log('New content is downloading.')
    },
    updated (reg) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
      Modal.confirm({
        title: '更新提醒',
        content: '新版本已经下载，点击确定使用最新版本!',
        cancelText: '稍等一会',
        mask: true,
        maskClosable: false,
        escToClose: false,
        onOk () {
          reg.waiting?.postMessage({ type: 'SKIP_WAITING' })
        }
      })
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

self.addEventListener('notificationclick', function (event) {
  const e: any = event
  let action = e.action
  console.log(`action tag: ${e.notification.tag}`, `action: ${action}`)

  switch (action) {
    default:
      console.log(`未处理的action: ${e.action}`)
      action = 'default'
      break
  }
  e.notification.close()
})
